// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__YYuUc","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2-IRP"};